export const EMBED_CODE_LABEL = "Embed code";
export const EMBED_CODE_OPEN = "View Code";
export const EMBED_CODE_COPY = "Copy";
export const EMBED_CODE_COPIED = "✓ Copied!";
export const EMBED_CODE_COPY_FAILED =
  "Couldn't copy — select the code and copy it yourself";
export const EMBED_CODE_COPIED_MS = 2000;
